import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("iframe", {
  style: {"border":"1px solid rgba(0, 0, 0, 0.1)"},
  width: "800",
  height: "450",
  src: "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FHaZ9EIhmpBNSJzoqmuoA4f%2FIceberg.navbar%3Fnode-id%3D316%253A317",
  allowfullscreen: ""
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "Just the one?", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("iframe", {
  style: {"border":"1px solid rgba(0, 0, 0, 0.1)"},
  width: "500",
  height: "550",
  src: "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FHaZ9EIhmpBNSJzoqmuoA4f%2FIceberg.navbar%3Fnode-id%3D382%253A7176",
  allowfullscreen: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("iframe", {
  style: {"border":"1px solid rgba(0, 0, 0, 0.1)"},
  width: "800",
  height: "450",
  src: "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FHaZ9EIhmpBNSJzoqmuoA4f%2FIceberg.navbar%3Fnode-id%3D1108%253A6562",
  allowfullscreen: ""
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ], 64 /* STABLE_FRAGMENT */))
}